import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";



@Injectable({
  providedIn: 'root'
})
export class ResourcesService {
  baseURL = environment.baseUrl + 'resource';

  constructor(private http: HttpClient) {
  }


  getAllResources(eventId:any){
    return this.http.get<any>(`${this.baseURL}/event/${eventId}`)
  }

  saveResource(eventId:any,selectedFile:any,name:string){
    const formData = new FormData();
    formData.append('file',selectedFile);
    return this.http.post<any>(`${this.baseURL}/save/event/${eventId}/resource/${name}`, formData);
  }

  deleteCertificate(fileId:any,eventId:any){
    return this.http.delete<any>(`${this.baseURL}/delete/file/${fileId}/event/${eventId}`)
  }
}
